export default {
  SET_AUTOMATIONS($state, automations) {
    $state.automations = automations;
  },
  ADD_AUTOMATION($state, automation) {
    $state.automations.unshift(automation);
  },
  UPDATE_AUTOMATION($state, automation) {
    const index = $state.automations.findIndex(a => a.id === automation.id);
    if (index !== -1) {
      $state.automations.splice(index, 1, automation);
    }
  },
  DELETE_AUTOMATION($state, id) {
    $state.automations = $state.automations.filter(a => a.id !== id);
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};
